import React from 'react';
import styles from '../help.scss';
import { StaticHTML } from '../../StaticHTML';
import HelmetComponent from "../../../utils/HelmetHelper";
const termsOfUse = `

  <div>
    <strong>Pravila i uvjeti korištenja</strong><br /><br />


    <strong>1. Temeljne odredbe</strong><br /><br />
    <ol>
      <li>Pravila i uvjeti korištenja vrijede za sve stranice na internetskoj adresi index.hr/oglasi, dalje u tekstu;
        Index Oglasi.</li>
      <li>Trgovačko društvo Index promocija d.o.o. vlasnik je Index Oglasa.</li>
      <li>Index Oglasi predstavljaju online platformu koja omogućuje javnu objavu i pretraživanje oglasa te povezivanje
        Korisnika.</li>
      <li>Korisnik je svaka osoba koja pristupa i/ili koristi Index Oglase, što podrazumijeva i neregistrirane i
        registrirane korisnike.</li>
      <br />

    </ol>

    <strong>2. Opće odredbe</strong><br /><br />
    <strong>2.1. Korištenje stranica i registracija</strong><br /><br />
    <ol>
      <li>Pristupanjem i/ili registracijom na stranicama Index Oglasi, Korisnik prihvaća sva utvrđena pravila i uvjete korištenja Index Oglasa te se obvezuje redovito pratiti njihove eventualne izmjene. Index promocija d.o.o. zadržava pravo promjena, modifikacija i dopuna uvjeta korištenja Index Oglasa u bilo kojem trenutku. Sve naknadne promjene stupaju na snagu u trenutku objave. Korisnik je dužan redovito čitati Uvjete i pravila korištenja te se smatra da je pristupanjem stranicama Index Oglasa upoznat s aktualnim pravilima i uvjetima njihova korištenja.</li>
      <li>Korisnici se Index Oglasima mogu služiti na jedan od sljedećih načina:
        <ul>
          <li>postavljanje/objava malih oglasa,;</li>
          <li>pretraživanje malih oglasa;</li>
          <li>za svako oglašavanje koje prelazi predviđene okvire ili korištenje oglasnika na neki drugi način, korisnike molimo da kontaktiraju društvo Index promocija d.o.o., na način naveden pod toč. 4.11.</li>
        </ul>
      </li>
      <li>U svrhu korištenja usluga Index Oglasa, Korisnik se obvezuje registrirati te u registracijskom obrascu popuniti potrebne opće i kontakt podatke. Korisnik ima mogućnost registracije i prijave na Index Oglase putem podataka za pristup društvenim mrežama koje su u trenutku korištenja dostupne Index Oglasima te kroz sučelje društvene mreže daje izričitu suglasnost korištenja i pohrane potrebnih podataka. Korisnik za točnost dostavljenih podataka jamči kaznenom i materijalnom odgovornošću te je obvezan održavati podatke točnim i ažurnim.</li>
      <li>Prikupljanje traženih podataka provodi se sukladno potrebama usluge za čije se korištenje Korisnik registrirao, a temelji se na odredbama Zakona o zabrani i sprječavanju obavljanja neregistrirane djelatnosti.</li>
      <li>Korisnik registracijom na Index Oglasima dopušta pohranu, uporabu i obradu navedenih podataka u svrhu djelovanja sustava, slanja sistemskih poruka i komunikaciju s korisničkom podrškom putem elektroničke pošte i telefona.</li>
      <li>Index promocija d.o.o. se obvezuje da će podatke Korisnika koristiti samo u svrhe za koje su dobiveni te u skladu s mjerodavnim propisima.</li>
      <li>Postavljanje oglasa tumači se zahtjev Korisnika da njegov oglas bude objavljen i dostupan na Index Oglasima. Samim time, Korisnik pristaje da objavljeni oglas sadrži i pojedine osobne podatke (ime, broj telefona i sl.) te prihvaća da su ti podaci dostupni i drugim osobama koje imaju pristup internetu.</li>
      <li>Korisnik ima pravo u svakom trenutku zatražiti zatvaranje svog korisničkog računa i brisanje oglasa. Index promocija d.o.o. će zatvoriti korisnički račun i oglase tog korisnika najkasnije u roku od 5 radnih dana od dana podnošenja zahtjeva, osim ako Korisnik u navedenom roku ne odustane od zatvaranja. Sve obavijesti o postupku zatvaranja korisničkog računa i brisanja podataka Korisnik će dobiti na adresu elektroničke pošte koju je prijavio u svrhu korištenja usluga Index Oglasa.</li>
      <li>Radi osiguranja točnosti podataka, sigurnosti i pravilnog funkcioniranja usluga, INDEX PROMOCIJA d.o.o. obrađuje samo one korisničke naloge koji sadrže sve obvezne podatke.
      Obvezni podaci uključuju, između ostalog, važeću i funkcionalnu e-mail adresu, koja predstavlja jedinstveni identifikator korisnika i tehnički je neophodna za prijavu, verifikaciju, komunikaciju i sigurnosne funkcije usluge koju pruža INDEX PROMOCIJA d.o.o..<br/>
      INDEX PROMOCIJA d.o.o. će provesti brisanje korisničkih računa koji:
        <ul>
          <li>ne sadrže sve obvezne podatke, uključujući valjanu e-mail adresu ili</li>
          <li>nisu pristupili svom korisničkom računu u periodu dužem od 3 mjeseca.</li>
        </ul>
      Takvi korisnički računi se smatraju neaktivnim ili nepotpunim i ne ispunjavaju minimalne tehničke uvjete za obradu i pružanje usluga.
      Brisanje takvih korisničkih računa može biti izvršeno bez prethodne individualne obavijesti.</p></li>
      <li>Index promocija d.o.o. vodi računa o zaštiti osobnih podataka sukladno mjerodavnim propisima te odredbama Pravila o privatnosti, kojima se detaljnije uređuju prikupljanje osobnih podataka, njihovo korištenje, sigurnost, čuvanje, brisanje, prijenos te korištenje alata.</li>
      <li>Index promocija d.o.o. je ovlašten u svakom trenutku zatvoriti korisnički račun onih korisnika koji krše ova Pravila i uvjeti korištenja ili na neki drugi način usporavaju ili ometaju rad Index Oglasa.</li>
      <li>Index promocija d.o.o. je ovlašten u svakom trenutku ukloniti profilne fotografije Korisnika, i to bez prethodne najave, ako profilna fotografija sadrži ilustracije govora mržnje ili psovke, pornografski sadržaj, fotografiju druge osobe, fotografiju s tuđeg korisničkog profila, fotografiju koja je zaštićena autorskim pravima ili drugi sadržaj koji se smatra neprimjerenim.</li>
      <li>Index promocija d.o.o. zadržava pravo, uz zatvaranje korisničkog računa, poduzeti i druge odgovarajuće mjere protiv korisnika koji krše ova Pravila i uvjeti korištenja.</li>
    </ol>

    <br />

    <strong>2.2. Odgovornost korisnika za sadržaj</strong><br /><br />
    <ol>
      <li>Korisnik je odgovoran za sav objavljeni sadržaj (objave, poruke, prikaze, tekstove, fotografije, ponude,
        videosnimke, oglase i drugi sadržaj) koji se prikazuje pod njegovim korisničkim imenom, neovisno o tome je li
        takav sadržaj objavljen direktno ili je prenesen ili povezan elektroničkom poveznicom (linkom) iz samog oglasa.
        <ol>
          <li>Naglašava se da Index Oglasi ne daju niti mogu davati bilo kakvu vrstu jamstava u pogledu točnosti,
            autentičnosti ili potpunosti sadržaja koji objavljuje Korisnik te je sva odgovornost isključivo na osobi pod
            čijim je korisničkim imenom sadržaj objavljen. U slučaju bilo kakvih zahtjeva trećih osoba, po bilo kakvoj
            osnovi, prema Index Oglasima, a vezano uz sadržaj objavljenih oglasa, Korisnik preuzima odgovornost i obvezu
            da poduzme sve radnje u svrhu zaštite društva Index promocija d.o.o. Svaki trošak i štetu koja nastane
            temeljem zahtjeva trećih osoba, i to po bilo kojoj osnovi vezanoj uz dostavljeni materijal, Korisnik je
            dužan nadoknaditi društvu Index promocija d.o.o.</li>
          <li>Sadržaj koji je nezakonit po bilo kojoj osnovi, a posebno sadržaj koji uključuje klevete, uvrede i
            prijetnje, koji je na drugi način štetan i/ili uznemirujući te kojim se na bilo koji način nanosi šteta ili
            uznemirava maloljetne osobe, smatra se nedopuštenim sadržajem. Isto se odnosi i na sadržaj kojim se krše
            autorska, srodna ili druga prava trećih osoba.</li>
          <li>Nedopuštenim sadržajem smatra se i iznošenje osobnih podatka drugih osoba, bez njihova izričitog
            odobrenja.</li>
          <li>Posebno se zabranjuju oglasi koji potiču na sudjelovanje u mrežnim marketinzima i piramidalnim shemama,
            kao i oglasi koji pozivaju na igranje nedopuštenih igara na sreću, oglasi vezani uz kreditna posredovanja i
            tarot usluge.</li>
          <li>Zabranjuje se oglašavanje duhanskih proizvoda i alkoholnih pića, lijekova, homeopatskih i medicinskih
            proizvoda, veterinsko - medicinskih proizvoda, droga, kemikalija i biocisnih pripravaka te oružja te će svi
            takvi oglasi odmah biti deaktivirani.</li>
          <li>Korisnik se, imajući u vidu sve navedeno, pristupom ovim stranicama obvezuje da neće objavljivati oglase
            ili drugi sadržaj koji je u suprotnosti s ovim pravilima te propisima, zakonima i Ustavom Republike
            Hrvatske.</li>
        </ol>
      </li>
      <br />
    </ol>


    <strong>2.3. Prijava nedozvoljenog sadržaja</strong><br /><br />
    <ol>
      <li>Korisnik prihvaća da Index Oglasi nisu u mogućnosti kontrolirati i nadzirati dopuštenost cjelokupnog
        objavljenog sadržaja.
        <ol>
          <li>Korisnik koji smatra da su mu nekim oglasom ili drugim sadržajem koji je objavljen na Index Oglasima
            povrijeđena prava ili ako smatra da je određeni sadržaj nezakonit ili nedopušten po bilo kojoj osnovi,
            obvezuje se takav sadržaj prijaviti odmah, uz navođenje razloga za podnošenje prijave.</li>
          <li>Index Oglasi će u najkraćem roku razmotriti osnovanost prijave korisnika i, u slučaju utvrđenja
            nedozvoljenog/nezakonitog sadržaja, poduzeti sve raspoložive mjere za njihovu zaštitu.</li>
        </ol>
      </li>
      <br />
    </ol>

    <strong>2.4. Pravila za postavljanje malih oglasa</strong><br /><br />
    <ol>
      <li>Svi oglasi postavljeni putem tipke „Predaj oglas“, kao i oni koji su preneseni direktno putem softvera s
        drugih stranica u bazu oglasa, smatraju se malim oglasima; dalje u tekstu; oglasi. Svi oglasi moraju biti
        napisani na hrvatskom jeziku.</li>
      <li>Naslov oglasa mora opisivati predmet prodaje te ga nije dopušteno naglašavati nepotrebnim ili ponavljajućim
        znakovima koji ne doprinose smislu naslova niti je u naslov dozvoljeno dodavati elektroničke poveznice (linkove)
        na druge web stranice.</li>
      <li>Svaki oglas mora sadržajno pripadati u primjerenu ili po smislu najbližu rubriku, a rubrika „Ostalo“
        predviđena je isključivo za oglase koje nije moguće svrstati u neku od drugih predviđenih rubrika. Nije
        dopuštena objava oglasa za isti predmet u dvije ili više različitih rubrika.</li>
      <li>Svaki oglas treba sadržavati konkretne podatke o predmetu ili usluzi koja se prodaje, s time da se opis nužno
        mora odnositi samo na predmet prodaje u naslovu oglasa. Nije dopušteno oglašavanje ostalih predmeta, usluga,
        potražnje ili bilo čega drugog što nije direktno predmet prodaje, definiran naslovom i/ili slikom. Slike u
        oglasu moraju biti slike predmeta koji se prodaje ili njemu istovjetnog predmeta. Posebno se zabranjuje objava
        logotipa, banera i slično, pod izlikom postavljanja malog oglasa.</li>
      <li>Nije dopušteno staviti jedan oglas za cijelu listu proizvoda, osim ako se ne radi o setu, što znači da je
        jednim oglasom dopušteno oglašavanje samo jednog predmeta ili jednog seta.</li>
      <li>Korisnik može imati samo jedno korisničko ime i za jedan predmet može predati samo jedan oglas. S druge
        strane, Korisnici nisu ograničeni količinom/brojem pojedinih oglasa koje mogu objaviti u Index Oglasima, dok se
        pridržavaju svih navedenih pravila.</li>
      <li>U sadržaju oglasa dopušteno je postavljanje jednog linka (internetska veza), i to samo ako vodi na dodatni
        opis predmeta ili seta u naslovu oglasa. Posebno se zabranjuju linkovi na ostale internetske oglasnike. Index
        oglasi zadržavaju pravo odlučivanja o odobrenju za postavljanje/objavu pojedinih linkova.</li>
      <li>Index Oglasi nisu odgovorni za štetu bilo koje vrste koja nastane kao posljedica međusobnih odnosa korisnika.
        Svi eventualni sporovi nastali iz takvih odnosa (temeljem istinitosti podataka o predmetu i cijeni ponude, o
        korisniku, oglašivaču, sadržaju ponude i sl.) rješavaju se isključivo između korisnika.</li>
      <br />
    </ol>

    <strong>2.5. Pravo na izmjenu ili uklanjanje oglasa </strong><br /><br />
    <ol>
      <li>Index Oglasi zadržavaju pravo eventualnih izmjena (lektorske intervencije i slične dopune) objavljenih oglasa,
        pridržavajući se pravila da sadržaj i smisao samog oglasa mijenja u najmanjoj mogućoj mjeri.</li>
      <li>Index Oglasi imaju pravo, bez ikakve najave ili pitanja, izmijeniti, premjestiti, izbrisati ili iz objave
        isključiti oglase koji grubo vrijeđaju ova Pravila i uvjete korištenja, ili je ispunjen jedan ili više od
        sljedećih uvjeta:
        <ul>
          <li>oglas je prijavljen ili je na drugi način utvrđeno da predstavlja nedozvoljen i/ili nezakonit sadržaj,
            odnosno da je protivan ovim Pravilima i uvjetima korištenja ili zakonima i Ustavu RH;</li>
          <li>oglas krši autorska prava i/ili druga prava intelektualnog vlasništva;</li>
          <li>oglas može uzrokovati štetu i/ili prekršiti prava intelektualnog vlasništva nekom drugom, na bilo koji
            način;</li>
          <li>oglas je u bilo kojem smislu uvredljiv;</li>
          <li>kad postoji sumnja na zloupotrebu Index Oglasa;</li>
          <li>oglas smatramo ne etičnim ili na bilo koji način neprimjerenim;</li>
          <li>oglas je predan u pogrešnu rubriku ili je u naknadno kreirana nova rubrika koja bolje odgovara sadržaju i
            predmetu oglasa;</li>
          <li>sadržaj oglasa sadrži govor mržnje, (dječje) pornografske materijale ili druge materijale koji su po
            propisima RH zabranjeni;</li>
          <li>postoji prijava ili osnovana sumnja da se oglašava ukradena ili ilegalna roba;</li>
          <li>kad cijena navedena u oglasu nije stvarna prodajna cijena;</li>
          <li>oglas na bilo koji način narušava kvalitetu doživljaja ili razine komunikacije na oglasniku.</li>
        </ul>
      </li>

      <br />
    </ol>

    <strong>2.6. Ostale dužnosti korisnika</strong><br />
    <br />
    <ol>
      <li>Objavom oglasa Korisnik neopozivo ovlašćuje Index Oglase da taj sadržaj koristi, kopira, objavljuje te
        distribuira i na drugim platformama, uz uvjet da se, u takvim objavama, ne objavljuju Korisnikovi osobni podaci,
        nego isključivo sadržaj oglasa i/ili link na stranicu Index Oglasi.</li>
      <li>Objavom oglasa Korisnik se obvezuje da će savjesno odgovarati na telefonske ili e-mail upite vezane uz predane
        oglase te da će povremeno pregledavati poštu na adresi s kojom se registrirao.</li>
      <li>Korisnik je odgovoran za sigurnost vlastite korisničke lozinke i ovime se obvezuje na njene periodičke
        izmjene. Index Oglasi ne odgovaraju i ne mogu odgovarati za slučajeve zlouporabe korisničke lozinke, ali se
        obvezuju djelovati u najkraćem razumnom roku, nakon što Korisnik prijavi eventualnu zlouporabu.</li>
      <li>Korisnicima u pisanoj komunikaciji na Index Oglasima nije dopušteno:
        <ul>
          <li>promovirati druge servise, proizvode i usluge;</li>
          <li>slati poveznice na druge internetske lokacije;</li>
          <li>nuditi posredovanje u prodaji ili iznajmljivanju;</li>
          <li>slati ponude za poslovnu suradnju koja nije oglašena;</li>
          <li>rabiti tuđe ime ili adresu e-pošte, lažno se predstavljati ili na bilo koji drugi način dovoditi drugog
            korisnika u zabludu da s njim kontaktira treća osoba, institucija ili poslovni subjekt;</li>
          <li>tražiti pomoć, donacije ili sponzorstva;</li>
          <li>dogovarati se s drugim oglašivačima o cijenama;</li>
          <li>psovati, slati poruke uvredljivog sadržaja i koristiti se govorom mržnje;</li>
          <li>slati poruke prijetećeg sadržaja ili zastrašivati;</li>
          <li>rabiti robote ili skripte za automatizirano slanje više poruka.</li>
        </ul>
      </li>
      <li>Korisnik pristaje povremeno primati elektroničku poštu koja je povezana s aktivnostima stranice Index Oglasi,
        prihvaćajući da ta elektronička pošta povremeno može sadržavati i reklamne poruke. Korisnik u bilo koje vrijeme
        može pismeno zahtijevati da Index Oglasi trajno ili privremeno prestanu koristiti njegove osobne podatke za
        slanje takvih poruka.</li>
      <li>S obzirom da Index Oglasi ne mogu korisnicima jamčiti pristup sadržaju postavljenog oglasa nakon što je
        istekao, korisnicima se predlaže samostalno pohranjivanje sadržaja i slika oglasa.</li>

    </ol>

    <strong>3. Elektronička komunikacija putem Index Oglasa </strong><br />
    <br />
    <ol>
      <li>Platforma Index Oglasi omogućuje korisnicima razmjenu privatnih poruka („inbox poruke“), isključivo u svrhu
        komunikacije vezane uz proizvode ili usluge ponuđene u oglasima, a radi:
      </li>

      <ul>
        <li> informiranja o detaljima oglasa; </li>
        <li> postizanja dogovora, odnosno trgovanja vezanog uz oglašeni proizvod ili uslugu; </li>
        <li> informiranja o ostalim proizvodima ili uslugama, ako je oglašivač poslovni korisnik. </li>

      </ul>

      <li>Razmjena privatnih poruka moguća je samo korisnicima koji imaju aktivne oglase ili koji su već prethodno
        međusobno komunicirali putem Index Oglasa.</li>
      <li>Poruke su privatne i vidljive isključivo pošiljatelju i primatelju, osim u slučajevima iz točke 3.3. ovih
        Uvjeta.</li>
    </ol>

    <br />

    <strong>3.1. Pravila korištenja i zabrane </strong><br />
    <br />
    <ol>
      <li>Korisnici su dužni koristiti komunikaciju putem platforme isključivo u skladu s njenom svrhom i pravilima
        pristojne, profesionalne i dopuštene komunikacije.</li>
      <li>Strogo je zabranjeno slanje i razmjena poruka koje sadrže, između ostalog:</li>

      <ul>
        <li> uvredljiv, prijeteći, diskriminatoran, obmanjujući ili neprimjeren sadržaj; </li>
        <li> prijevare ili pokušaj prijevare (npr. traženje uplata unaprijed, lažno predstavljanje, traženje osobnih
          podataka i slično); </li>
        <li> zahtjeve za komunikaciju izvan platforme s ciljem izbjegavanja pravila ili nadzora; </li>
        <li> sadržaj koji na bilo koji način krši propise Republike Hrvatske.</li>

      </ul>

    </ol>

    <br />

    <strong>3.2.Prijava neprimjerenog sadržaja </strong><br />
    <br />
    <ol>
      <li>Korisnici mogu prijaviti neprimjeren sadržaj u porukama kroz sučelje Index Oglasa, putem funkcije „Prijavi
        korisnika“.</li>
      <li>Nakon zaprimanja prijave, ovlašteni administrator će imati pravo pristupa isključivo prijavljenoj komunikaciji
        između korisnika i samo u mjeri nužnoj za provjeru osnovanosti prijave te poduzimanja odgovarajućih mjera.</li>
      <li>Radi zaštite korisnika, sprječavanja zloporabe komunikacije i otkrivanja neželjene pošte, Index Oglasi
        zadržavaju pravo, bez obavijesti, poduzeti sljedeće mjere:</li>

      <ul>
        <li> provjeriti i analizirati sadržaj prijavljenih poruka; </li>
        <li> blokirati korisnika ili mu onemogućiti daljnje komuniciranje putem poruka; </li>
        <li> izdati opomenu korisniku;</li>

      </ul>

      <li>Index Oglasi neće pristupati privatnim porukama korisnika, osim u prethodno navedenim slučajevima.</li>
      <li>Korisnici su, korištenjem Index oglasa i prihvaćanjem ovih Općih uvjeta, upoznati i suglasni da Index Oglasi
        mogu pristupiti sadržaju privatnih poruka isključivo u situacijama propisanim ovom odredbom, radi provjere
        osnovanosti prijave, zaštite korisnika i sprječavanja zlouporaba.</li>

    </ol>

    <br />

    <strong>3.3. Čuvanje i obrada komunikacije između korisnika </strong><br />
    <br />
    <ol>
      <li>Poruke između korisnika automatski se brišu nakon proteka dvanaest mjeseci od posljednje aktivnosti u
        komunikaciji, odnosno šest mjeseci nakon brisanja korisničkog računa korisnika. Iznimno, podaci se mogu čuvati
        dulje, u mjeri nužnoj za ispunjenje zakonske obveze ili radi zaštite pravnih zahtjeva.</li>
      <li>Obrada osobnih podataka u svrhu zaštite korisnika, sprječavanja zlouporaba i osiguravanja sigurnog korištenja
        platforme, kako je detaljnije objašnjeno u odjeljku 3.3. ovih Uvjeta, temelji se na legitimnom interesu Index
        Oglasa.</li>
      <li>Sadržaj poruka ne koristi se u druge svrhe (primjerice marketing, automatizirano profiliranje ili analizu
        sadržaja).</li>

    </ol>

    <br />

    <strong>3.4. Odnos prema trećim stranama i nadležnim tijelima </strong><br />
    <br />
    <ol>
      <li>Index Oglasi ne prijavljuju samoinicijativno sadržaj ili komunikaciju između korisnika nadležnim tijelima.
      </li>
      <li>Na zahtjev nadležnog tijela, Index Oglasi mogu dostaviti podatke i sadržaje u mjeri u kojoj je to propisano
        zakonom.</li>
      <li>Index Oglasi nisu sudionik komunikacije između korisnika te ne snose odgovornost za sadržaj, točnost
        informacija, dogovore niti ishod komunikacije koja se odvija između korisnika putem platforme.</li>

    </ol>

    <br />

    <strong>3.5. Izmjene i obavijest korisnicima </strong><br />
    <br />
    <ol>
      <li>Index Oglasi zadržavaju pravo izmijeniti ovaj dio Uvjeta korištenja, sukladno razvoju funkcionalnosti i
        važećim propisima o zaštiti osobnih podataka.</li>

    </ol>

    <br />



    <strong>4. Sustav ocjenjivanja korisnika </strong><br />
    <br />
    <strong>4.1. Sustav ocjenjivanja </strong><br /><br />
    <ol>
      <li>Platforma Index Oglasi omogućuje korisnicima međusobno ocjenjivanje putem sustava ocjena i komentara (dalje: Sustav ocjenjivanja).</li>
      <li>Pravo na ocjenjivanje imaju korisnici između kojih je prethodno postojala komunikacija putem privatnih poruka („inbox poruke“) unutar platforme.
      </li>
      <li>Sustav ocjenjivanja sastoji se od numeričke ocjene (1–5) te obveznog tekstualnog komentara. </li>
    </ol>
    <br />
    <strong>4.2. Javnost i transparentnost ocjena</strong><br /><br />
    <ol>
      <li>Korištenjem Sustava ocjenjivanja korisnici su suglasni da se dodijeljene ocjene i komentari javno objavljuju i prikazuju na profilu korisnika.</li>
      <li>Korisnik koji je zaprimio ocjenu ima pravo na jedan javni odgovor na komentar, koji postaje sastavni dio prikaza ocjene.
      </li>
      <li>Ocjene i komentari predstavljaju subjektivno mišljenje korisnika te ne odražavaju stavove Index Oglasa. Index Oglasi ne jamče njihovu točnost niti objektivnost. </li>
    </ol>
    <br />
    <strong>4.3. Pravila sadržaja i moderacija</strong><br /><br />
    <ol>
      <li>Svaki komentar, prije objave, podliježe ručnoj (manualnoj) moderaciji od strane administratora, isključivo radi provjere usklađenosti s pravilima platforme.</li>
      <li>Nije dopušteno objavljivanje komentara koji sadrže:</li>
      <ul>
      <li>uvredljiv, klevetnički, diskriminatoran ili neprimjeren sadržaj;</li>
      <li>psovke, prijetnje ili govor mržnje;</li>
      <li>osobne podatke trećih osoba; ili</li>
      <li>netočne ili obmanjujuće tvrdnje iznesene u zlonamjernoj namjeri.</li>
      </ul>
      <li>Index Oglasi zadržavaju pravo odbiti objavu ili ukloniti komentar koji krši ova pravila.</li>
    </ol>
    <br />
        <strong>4.4. Prijava ocjena i uvid u komunikaciju</strong><br /><br />
    <ol>
      <li>Korisnici mogu prijaviti ocjenu ili komentar koji smatraju lažnim, neosnovanim ili protivnim pravilima platforme.</li>
      <li>U svrhu zaštite integriteta Sustava ocjenjivanja, Index Oglasi zadržavaju pravo pristupa komunikaciji između korisnika isključivo u slučaju zaprimljene prijave i u mjeri nužnoj radi provjere osnovanosti prijave i rješavanja sporova.
      </li>
      <li>Index Oglasi ne vrše proaktivni nadzor privatnih poruka između korisnika. </li>
    </ol>
    <br />
        <strong>4.5.  Trajanje i uklanjanje ocjena</strong><br /><br />
    <ol>
      <li>Ocjene i komentari čuvaju se i ostaju povezani s korisničkim računom dok je račun aktivan.</li>
      <li>Nakon brisanja korisničkog računa, ocjene i komentari brišu se ili anonimiziraju najkasnije u roku od 30 dana od brisanja računa, osim ako je dulje čuvanje nužno radi ispunjenja zakonskih obveza ili zaštite pravnih zahtjeva.
      </li>
      <li>Index Oglasi zadržavaju pravo uklanjanja ocjena i komentara koji:</li>
      <ul>
      <li>krše Uvjete korištenja platforme;</li>
      <li>predstavljaju zlouporabu Sustava ocjenjivanja; ili</li>
      <li>su očito lažni ili zlonamjerni.</li>
      </ul>
      <li>Administratorski logovi čuvaju se do 24 mjeseca radi zaštite legitimnih interesa platforme, sigurnosti sustava i rješavanja prigovora.</li>
    </ol>
<br />
    <strong>4.6. Zabrana manipulacije sustavom</strong><br /><br />
    <ol>
      <li>Nije dopušteno korištenje Sustava ocjenjivanja u svrhu manipulacije reputacijom korisnika, uključujući:</li>
      <ul>
      <li>koordinirano davanje lažnih ocjena;</li>
      <li>otvaranje ili korištenje više korisničkih računa radi utjecaja na ocjene; ili</li>
      <li>razmjenu pogodnosti u zamjenu za pozitivnu ocjenu.</li>
      </ul>
      <li>Index Oglasi zadržavaju pravo ograničiti ili onemogućiti pristup Sustavu ocjenjivanja u slučaju sumnje na zlouporabu.</li>
    </ol>
<br />
    <strong>4.7. Odgovornost</strong><br /><br />
    <ol>
      <li>Korisnik je isključivo odgovoran za sadržaj ocjena i komentara koje objavljuje.</li>
      <li>Index Oglasi ne snose odgovornost za sadržaj komentara niti za eventualne posljedice koje mogu proizaći iz Sustava ocjenjivanja, osim u mjeri u kojoj je odgovornost propisana prisilnim propisima.</li>
    </ol>

    <strong>5. Korištenje osobnih podataka </strong><br />
    <br />
    <ol>
      <li>Index Oglasi se obvezuju da će dobivene podatke koristiti samo u svrhe za koje su dobiveni, a to je u svrhu
        djelovanja sustava te za komunikaciju elektroničkom poštom, što uključuje uporabu i obradu. Korisnik
        registracijom i korištenjem ovog oglasnika to izrijekom dopušta.</li>
      <li>Za analizu svoje internetske stranice koristimo software pomoću kojeg stječemo znanje potrebno za
        poboljšavanje kvalitete forme i sadržaja našeg oglasnika. S tim u vezi koriste se i tzv. kolačići (tekstovne
        datoteke koje se pohranjuju na računalu posjetitelja internetske stranice) koji omogućavaju prepoznavanje
        korisnika prigodom svakog idućeg posjeta stranici. Kolačići se mogu odbiti ili izbrisati putem odgovarajućih
        alata, no to može dovesti do ometanja nekih funkcija Index Oglasa.. Osim kolačića prikupljamo i pohranjujemo i
        neke tehničke podatke, uključujući trenutnu IP adresu korisnika, podatke o pregledniku i slično. Naglašavamo da,
        ni u kom slučaju, ne dolazi do identifikacije osoba koje stoje iza tih podataka ni do prikupljanja osobnih
        podataka niti se ti podaci povezuju s osobnim podacima koje je Korisnik eventualno obznanio. Korištenjem ove
        internetske stranice dajete svoju suglasnost za gore opisani način provođenja analize korištenja ove internetske
        stranice. Više o kolačićima možeš pročitati <a href="https://www.index.hr/oglasi/uvjeti-koristenja/9">ovdje.</a>
      </li>
      <li>Ako odlučiš koristiti Google usluge i dozvoliš korištenje Google Analytics alata na našim stranicama
        informiraj se na koji način Google upravlja tvojim podacima <a
          href="https://policies.google.com/privacy/frameworks?hl=hr&gl=hr">ovdje.</a> </li>
    </ol>

    <br />
    <strong>6. Prijelazne i završne odredbe</strong><br />
    <br />
    <ol>
      <li>Zabranjeno je kopiranje i uporaba bilo kojeg dijela stranica Index Oglasi, uključivo sa svim podacima koje
        daju korisnici, bez prethodnog pismenog dopuštenja društva Index promocija d.o.o.</li>
      <li>Index promocija d.o.o. ne odgovara za bilo kakvu štetu koja bi mogla nastati zbog prekida dostupnosti, ne
        objavljivanja, odnosno brisanja oglasa ili pogrešaka u djelovanju web stranica.</li>
      <li>Index promocija d.o.o. ne odgovara za bilo kakve troškove koji bi mogli nastati Korisniku, a koji mogu nastati
        zbog korištenja stranica Index Oglasi.</li>
      <li>Index Oglasi sadrže poveznice na internetske stranice drugih poslužitelja. Index promocija d.o.o. ne odgovara
        za sadržaj internetskih stranica treće strane, ne jamči i ne preuzima odgovornost za štetan, ilegalni sadržaj
        ili druga zakonska kršenja na internetskim stranicama trećih strana. Index promocija d.o.o. će u najkraćem
        mogućem vremenu ukloniti bilo koju poveznicu ili sadržaj nakon što se u potpunosti uvjeri da on krši pozitivne
        zakonske propise ili je na bilo koji način štetan ili nepoželjan.</li>
      <li>Index Oglasi zadržavaju pravo trenutno s popisa korisnika brisati one korisnike koji su prekršili ova Pravila
        i uvjete ili na drugi način usporavali ili ometali rad stranica. Index promocija d.o.o. također zadržava pravo
        poduzeti dodatne odgovarajuće mjere protiv takvih osoba.</li>
      <li>Uvjeti i odnosi između korisnika i društva Index promocija d.o.o. podliježu zakonima Republike Hrvatske. U
        slučaju spora nadležan je stvarno nadležan sud u Zagrebu.</li>
      <li>Index promocija d.o.o. nije ni prodavatelj prikazane robe i usluga ni predstavnik ili pomoćnik trgovca.
        Korisnik i Index promocija d.o.o. stoga ne ulaze ni u kakve vrste ugovornih odnosa za prikazanu robu i usluge.
      </li>
      <li>Index promocija d.o.o. ne preuzima jamstvo za potpunost, aktualnost, točnost i kvalitetu robe i usluga koje su
        prikazane na stranicama Index Oglasi. Posebice se ne preuzima jamstvo za to da se roba i usluge prikazane na
        stranicama Index Oglasi mogu zaista i nabaviti po navedenim uvjetima kod dotičnog trgovca.</li>
      <li>Objava podataka pojedinog trgovca, proizvođača ili davatelja usluge na Index Oglasima ne znači da Index
        promocija d.o.o. preporučuje taj proizvod, trgovca, proizvođača ili davatelja usluga.</li>
      <li>Ova Pravila i uvjeti korištenja primjenjuju se i vrijede od __. ožujka 2024. godine.</li>
      <li>Pisani prigovor, sukladno odredbi 10. Zakona o zaštiti potrošača možete dostaviti u pisanom obliku: na adresu
        sjedišta društva: Radnička cesta 41, 10 000 Zagreb; ili putem e-pošte na adresu: <a
          href="mailto:oglasi@index.hr">oglasi@index.hr</a></li>
      <li>Odgovor na prigovor obvezujemo se dati u roku određenom Zakonom o zaštiti potrošača.</li>

      <br />
    </ol>
    U Zagrebu, 20. studenoga 2025.
  </div>


  `
  ;

const TermsOfUse = () => (
  <div className={styles.container}>
    <HelmetComponent
      title={`${"Uvjeti korištenja"} | ${"INDEX OGLASI"}`}
    />
    <div className={styles.title}>Uvjeti korištenja</div>
    <StaticHTML content={termsOfUse} />
  </div>
);

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/components/Help/TermsOfUse/TermsOfUse.tsx